// extracted by mini-css-extract-plugin
export default {"container":"TA-z","finalSalePdpEnhancements":"UA-z"};